import { ProductoCementoDto } from '../../../models/producto-cemento.dto';
import { ProductoCemento } from '../../../models/producto-cemento.model';
import { ProductoCementoVm } from '../../../models/producto-cemento.vm';

function asText(value: unknown): string {
  if (typeof value === 'string') {
    return value.trim();
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value).trim();
  }
  return '';
}

function asPositiveInteger(value: unknown): number {
  const numericValue = Number(value);
  return Number.isInteger(numericValue) && numericValue > 0 ? numericValue : 0;
}

function asNullableNumber(value: unknown): number | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
}

function asBoolean(value: unknown): boolean {
  if (typeof value === 'boolean') {
    return value;
  }
  if (value === 1 || value === '1') {
    return true;
  }
  if (value === 0 || value === '0') {
    return false;
  }
  return false;
}

export class ProductoCementoMapper {
  static toDomain(dto: ProductoCementoDto): ProductoCemento {
    const nombreComuna = asText(dto.nombreComuna) || asText(dto.comuna);
    return {
      id: asPositiveInteger(dto.id),
      nombreComuna,
      producto: asText(dto.producto),
      nombrePublicacion: asText(dto.nombrePublicacion),
      multiplo: asPositiveInteger(dto.multiplo),
      unidad: asText(dto.unidad),
      incoterms: asText(dto.incoterms),
      skuPos10: asText(dto.skuPos10),
      skuPos20: asText(dto.skuPos20),
      skuPos30: asText(dto.skuPos30),
      precioBruto: asNullableNumber(dto.precioBruto),
      tipoCamion: asText(dto.tipoCamion),
      activo: asBoolean(dto.activo),
    };
  }

  static toVm(dto: ProductoCementoDto): ProductoCementoVm {
    const item = ProductoCementoMapper.toDomain(dto);
    const baseKey = [item.nombreComuna, item.producto, item.skuPos10].join('|');
    return {
      ...item,
      trackId: String(item.id || baseKey),
    };
  }

  static toVmList(dtos: ProductoCementoDto[]): ProductoCementoVm[] {
    return dtos.map((dto) => ProductoCementoMapper.toVm(dto));
  }
}
